import type { OfferVehicle } from 'BrokerTsLib/src/dtos'
import { createContext, useContext } from 'react'

import { useCalculateOffers, useGetOffers } from '../hooks/useOffer'
import type { BaseOffersProviderProps, IOffersContext} from './OffersProvider'
import { defaults, OffersProvider } from './OffersProvider'

export const offersVehicleContext = createContext<IOffersContext<OfferVehicle>>(defaults as any)

export function OffersVehicleProvider(props: BaseOffersProviderProps) {
  return (
    <OffersProvider
      signalRCalcFinishedEventName='CalcFinished'
      useGetOffers={useGetOffers}
      useCalculateOffers={useCalculateOffers}
      context={offersVehicleContext as any}
    >
      {props.children}
    </OffersProvider >
  )
}

export const useOffersVehicleContext = () => {
  const context = useContext(offersVehicleContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useOffersVehicleContext must be used within a OffersVehicleProvider!')
  }

  return context
}